import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {EntityConglomerateLinkContainer} from '../../../../../../models/aggregates/erp/conglomerate';
import {BaseApiTemplateService} from '../../shared/base-api-template-service.model';
import {Core2Config} from '../../shared/core2Config';

@Injectable({providedIn: 'root'})
export class EntityConglomerateLinkService extends BaseApiTemplateService<EntityConglomerateLinkContainer> {

    constructor(http:HttpClient) {
        super();
        this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'entity-conglomerate-links/backoffice-ep';
        this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'entity-conglomerate-links/backoffice-ep';
        this.httpClient = http;
    }  
  
  }